/*
 * @flow
 */

import addClickHandler from './addClickHandler';
import replaceEmbed from './replaceEmbed';
import registerWidget from './registerWidget';
import triggerOpen from './triggerOpen';
import reloadWidget from './reloadWidget';

export {
  addClickHandler,
  replaceEmbed,
  triggerOpen,
  registerWidget,
  reloadWidget
};



// WEBPACK FOOTER //
// ./src/bootstrap/plugins/index.js